import { Footer } from "./Footer";
import { Header } from "./Header";
import { RouteExperience } from "./RouteExperience";
import { isConfigured } from "../lib/chain";

export function Layout() {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Header />
      <div className="workspace">
        <main id="main-content">
          {!isConfigured && (
            <div className="deployment-notice" role="status">
              <strong>A fresh start is on the way.</strong>
              <span>New contracts are being prepared. Previous markets are no longer connected to this website.</span>
            </div>
          )}
          <RouteExperience />
        </main>
        <Footer />
      </div>
    </div>
  );
}
